import React, { Component } from "react"
import PropTypes from "prop-types"

//import './file-upload.scss';

class FileUpload extends Component {
    constructor(props) {
        super(props)

        this.onChange = this.onChange.bind(this)
        this.onDelete = this.onDelete.bind(this)

        this.state = {
            filename: null,
            errorMessage: "",
        }
    }

    componentDidMount() {
        if (this.props.defaultValue && this.props.defaultValue !== "") $(this.container).addClass("has-file")
    }

    onDelete(e) {
        this.setState({ filename: null })
        this.fileupload.value = null

        this.props.onDelete()

        $(this.container).removeClass("has-file")
    }

    onChange(e) {
        let el = e.target,
            file = el.files[0]

        const fileRegex =
            /.+\.(svg|doc|docx|xls|xlsx|ppt|pptx|pdf|txt|zip|rar|ico|avi|mpg|mpeg|mp3|wmv|mov|wav|mp4|webm|ogv|export)/

        const imageRegex = /.+\.(jpg|jpeg|jpe|gif|bmp|png)/

        console.log(file)

        this.setState({ errorMessage: null })

        if (imageRegex.test(file.name)) {
            let reader = new FileReader()

            reader.onload = () => {
                // send data back to parent
                this.props.onSelect(file, reader.result, el)

                $(this.container).addClass("has-file")
            }

            reader.readAsDataURL(file)
        } else if (fileRegex.test(file.name)) {
            // *.mp4, text files, *.mp3, office files (*.docx, *.xls, ...), *.zip, *.pdf

            // send data back to parent
            this.props.onSelect(file, null, el)

            $(this.container).addClass("has-file")

            this.setState({ filename: file.name })
        } else {
            this.fileupload.value = null
            this.setState({ errorMessage: "فرمت فایل غیرمجاز است" })
            console.log("File not supported!")
        }
    }
    render() {
        return (
            <>
                <div ref={(el) => (this.container = el)} className="file-upload">
                    {this.props.type === "image" ? (
                        <img ref={(el) => (this.img = el)} src={this.props.defaultValue} />
                    ) : (
                        <span>{this.props.defaultValue}</span>
                    )}

                    <i className="icon-add" onClick={() => this.fileupload.click()} />
                    <i className="icon-close" onClick={this.onDelete} />

                    <input type="file" ref={(el) => (this.fileupload = el)} onChange={this.onChange} />
                    {this.state.filename && (
                        <div
                            className="file-name"
                            style={{
                                maxWidth: "140px",
                                color: "#ed5565",
                                textAlign: "center",
                                padding: "5px",
                            }}
                        >
                            {this.state.filename}
                        </div>
                    )}
                    {this.state.errorMessage && (
                        <div
                            className="file-name"
                            style={{
                                maxWidth: "140px",
                                color: "#ed5565",
                                textAlign: "center",
                                padding: "5px",
                            }}
                        >
                            {this.state.errorMessage}
                        </div>
                    )}
                </div>
                <p className="float-label-alternative">
                    فرمت های مجاز
                    <span className="dashboard__help help__right">
                        <i className="icon-help"></i>
                        <span>
                            .jpg .jpeg .jpe .gif .bmp .png .doc .docx .xls .xlsx .ppt .pptx .pdf .txt .zip .rar .ico
                            .avi .mpg .mpeg .mp3 .wmv .mov .wav .mp4 .webm .ogv .export{" "}
                        </span>
                    </span>
                </p>
            </>
        )
    }
}

FileUpload.defaultProps = {
    type: "image",
}

FileUpload.propTypes = {
    defaultValue: PropTypes.string,
    type: PropTypes.oneOf(["image", "file"]),
    onDelete: PropTypes.func,
    onSelect: PropTypes.func,
}

export default FileUpload
